export const asBase64EncodedJson = (value: any) => btoa(JSON.stringify(value));
